module.exports = false;


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/core-js/modules/_library.js
// module id = 84
// module chunks = 1